interface DateTimeProps {
    date: Date;
    showTime?: boolean;
}

export const DateTime: React.FC<DateTimeProps> = ({ date, showTime = true }) => {
    if (!date) return null;
    const jsDate = new Date(date);
    const dateStr = jsDate
        .toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
        })
        .replace(/(\w{3}) (\d+), (\d+)/, "$1. $2, $3");
    if (!showTime) {
        return <span style={{ whiteSpace: "nowrap" }}>{dateStr}</span>;
    }
    const timeStr = jsDate.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
    });
    return (
        <span style={{ whiteSpace: "nowrap" }}>
            {dateStr} · {timeStr}
        </span>
    );
};
